import { render, staticRenderFns } from "./PackagePurchase.vue?vue&type=template&id=64ceefda&scoped=true&"
import script from "./PackagePurchase.vue?vue&type=script&lang=js&"
export * from "./PackagePurchase.vue?vue&type=script&lang=js&"
import style0 from "./PackagePurchase.vue?vue&type=style&index=0&id=64ceefda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ceefda",
  null
  
)

export default component.exports